function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/* eslint-disable */
// This icon has been generated. Do not edit it directly.
import React from 'react';
var IconLinkedin = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(IconLinkedin, _React$PureComponent);
  function IconLinkedin() {
    _classCallCheck(this, IconLinkedin);
    return _possibleConstructorReturn(this, _getPrototypeOf(IconLinkedin).apply(this, arguments));
  }
  _createClass(IconLinkedin, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        color = _this$props.color,
        onClick = _this$props.onClick,
        size = _this$props.size,
        style = _this$props.style,
        width = _this$props.width,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["height", "color", "onClick", "size", "style", "width", "className"]);
      return React.createElement("svg", _extends({}, rest, {
        height: height || size,
        width: width || size,
        onClick: onClick,
        style: style,
        className: className,
        fill: color,
        viewBox: "0 0 512 512"
      }), React.createElement("path", {
        d: "M156.367 419.42H86.956V197.334h69.411V419.42zm-36.479-249.876h-.505c-25.118 0-41.392-16.969-41.392-38.484 0-21.938 16.768-38.563 42.379-38.563 25.595 0 41.352 16.59 41.846 38.506 0 21.51-16.251 38.541-42.328 38.541m314.12 249.876h-78.689V304.492c0-30.087-12.287-50.614-39.363-50.614-20.723 0-32.215 13.86-37.582 27.215-2 4.781-1.689 11.446-1.689 18.159V419.42H198.73s1.01-203.583 0-222.086h77.955v34.845c4.607-15.237 29.502-36.995 69.277-36.995 49.305 0 88.047 31.962 88.047 100.734V419.42z"
      }));
    }
  }]);
  return IconLinkedin;
}(React.PureComponent);
_defineProperty(IconLinkedin, "styleRoot", 'IconLinkedin');
_defineProperty(IconLinkedin, "defaultProps", {
  size: 32,
  color: '#333'
});
export { IconLinkedin as default };